<template lang="pug">
    #TenantCenter.main-page-tenant-center.TenantCenter-background.page-noScroll.pb-0.position-relative
        loadingOverlay(v-if='loading' message='Loading . . .' :zIndex='999' attach)
        div.height_100(v-if='!loading')
            v-card.deal-tab-card.rounded-card.d-flex.justify-center(flat color='transparent')
                #page-inner.pt-0.d-flex.justify-center.tenantcenter_tab
                    v-tabs(v-model='tab' background-color='transparent'  id='gptupload' )
                        v-tab(v-for='item in tabs' :key='item.key' :href='`#tab-${item.id}`'  style='display:flex; justify-content:center !important;  text-transform: capitalize !important;')
                            span.spna {{ item.name }}
                        v-row.mb-5.justify-end(v-if='tab==="tab-1"' no-gutters)
                            v-btn.mr-2.align-center(v-if='tab==="tab-1" && canManageTenants' :ripple='false'  height='40' color='#18bedf' dark depressed @click='tenantPipelineDialog=true' :disabled='inProcessing') 
                                v-icon.mr-1(size="12") icon-add
                                span {{$t('TENANT_PIPELINE.BUTTON')}}
                            v-btn.mr-2.align-center(v-if='tab==="tab-1" && canManageTenants' :ripple='false'  height='40' color='#18bedf' dark depressed @click='addTenantDialog=true' :disabled='inProcessing') 
                                v-icon.mr-1(size="12") icon-add
                                span {{$t('TENANTCENTER.CREATE_TENANT')}}
                            v-btn.mr-2.align-center(v-if='tab==="tab-1" && canManageTenants' :ripple='false' height='40' color='#18bedf' dark depressed @click='addSuperUserDialog=true' :disabled='inProcessing') 
                                v-icon.mr-1(size="12") icon-add
                                span {{$t('TENANTCENTER.CREATE_SUPERUSER')}}
                            v-btn.align-center(v-if='tab==="tab-1" && canManageTenants' :ripple='false' height='40' color='#18bedf' dark depressed @click='updateSubscriptionDialog=true' :disabled='inProcessing') 
                                v-icon.mr-1(size="12") icon-add
                                span {{$t('TENANTCENTER.UPDATE_SUBSCRIPTION')}}
                            v-btn.ml-3.pa-0(v-if='showRefreshBtn' v-hide-element='false' text height='38' color='gary' :title=`$t('GENERAL.REFRESH')` @click='refresh')
                                v-icon mdi-refresh
                                span {{$t('GENERAL.REFRESH')}}
                        v-tab-item.tab-item-bg(key='tenantList' value='tab-1' :transition='false' :reverse-transition='false' style='min-height:0px;' color='rgba(255, 255, 255, 0.7)')
                            v-row.setting-title.align-center.py-3.px-4(no-gutters)
                                v-data-table.mt-0.dashboard-table(:headers="tenantListHeaders" :items="tenantListItems"  )
                                    template( v-slot:item.schema_name="{ item }" )
                                        .ellipsis
                                            span.ellipsis(:title='item.schema_name') {{ item.schema_name }}
                                    template( v-slot:item.name="{ item }" )
                                        .ellipsis
                                            span.ellipsis(:title='item.name') {{ item.name }}
                                    template( v-slot:item.description="{ item }" )
                                        .ellipsis
                                            span.ellipsis(:title='item.description') {{ item.description }}
                                    template( v-slot:item.created_on="{ item }" )
                                        .ellipsis
                                            span.ellipsis(:title='item.created_on') {{ new Date(item.created_on).toLocaleDateString() }}
                                    template( v-slot:item.subscription_end_date="{ item }" )
                                        .ellipsis
                                            span.ellipsis(:title='item.subscription_end_date') {{ item.subscription_end_date ? new Date(item.subscription_end_date).toLocaleDateString():'' }}
                                    template( v-slot:item.licensed="{ item }" )
                                        .ellipsis
                                            span.ellipsis(:title='item.licensed') {{ item.licensed }}
                                    template( v-slot:item.actions="{ item }" )
                                        v-btn(icon @click='toUserListPage(item)' :disabled='inProcessing' :title='$t("TENANTCENTER_USER_LIST.LIST")')
                                            v-img(src="@/assets/images/Tenantusers.svg" max-width="20px" width="20px")
                                        v-btn(icon title='Load Data' @click='onClicktoLoadData(item)' :disabled='inProcessing' v-if='canManageTenants')
                                            v-img(src="@/assets/images/Loaddata.svg" max-width="20px" width="20px")
                        v-tab-item(key='tenantUsageAnalysis' value='tab-2' :transition='false' :reverse-transition='false' style='min-height:0px;' )
                            v-row.pl-9.setting-title.align-center.py-3.px-4.scrollbar(no-gutters)
                                tenatUsageAnalysis(:tenantListItems='tenantListItems')
        v-dialog(v-model='addTenantDialog' width='480' content-class='statusDialog' v-if='addTenantDialog' persistent)
            add-tenant-dialog(@emitAddTenatDialog='onEmitAddTenantDialog' @emitNormalAddTenant='onEmitNormalAddTenant')
        v-dialog(v-model='tenantPipelineDialog' width='880' content-class='statusDialog' v-if='tenantPipelineDialog' persistent)
            tenant-pipeline-dialog(@emitTenantPipelineDialog='onEmitTenantPipelineDialog' :tenantListItems='tenantListItems')
        v-dialog(v-model='addSuperUserDialog' width='480' content-class='statusDialog' v-if='addSuperUserDialog' persistent)
            add-superuser-dialog(@emitAddSuperUserDialog='onEmitAddSuperUserDialog' :tenantListItems='tenantListItems')
        v-dialog(v-model='updateSubscriptionDialog' width='480' content-class='statusDialog' v-if='updateSubscriptionDialog' persistent)
            update-subscription-dialog(@emitUpdateSubscriptionDialog='onEmitUpdateSubscriptionDialog' :tenantListItems='tenantListItems')
        v-dialog(v-model='successDialog' width='360' content-class='statusDialog')
            success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
        v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' persistent)
            message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message' )
        v-dialog(v-model='errorDialog' width='360'  content-class='statusDialog')
            error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
</template>
<script>
    import i18n from '/common/plugins/vue-i18n.js';
    import TenantCenterService from "@/services/TenantCenterService";
    import addTenantDialog from "@/components/TenantCenter/addTenant";
    import addSuperuserDialog from "@/components/TenantCenter/addSuperUser";
    import updateSubscriptionDialog from "@/components/TenantCenter/updateSubscription";
    import tenantPipelineDialog from "@/components/TenantCenter/Pipeline/tenantPipelineDialog";
    import tenatUsageAnalysis from "@/components/TenantCenter/tenatUsageAnalysis";
    import successDialog from "@/components/Dialog/successDialog";
    import messageDialog from '@/components/Dialog/messageDialog';
    export default {
        name: "TenantCente-Tenant-List",
        components: {
            addTenantDialog,
            addSuperuserDialog,
            updateSubscriptionDialog,
            tenantPipelineDialog,
            tenatUsageAnalysis,
            successDialog,
            messageDialog,
        },
        data() {
            return{
                loading:false,
                tab: null,
                tabs: [
                    {
                        id: 1,
                        key: 'tenantList',
                        name: i18n.t('TENANTCENTER.TENANTLIST')
                    },
                    {
                        id: 2,
                        key: 'tenantUsageAnalysis',
                        name: i18n.t('TENANTCENTER.USAGE_ANALYSIS')
                    },
                   
                ],
                tenantListHeaders:[
                    {
                        text: i18n.t('TENANTCENTER_TENANT_LIST.SCHEMANAME'),
                        align: 'left',
                        sortable: false,
                        value: 'schema_name',
                        class: "transparent",
                    },
                    {
                        text: i18n.t('TENANTCENTER_TENANT_LIST.TENANTNAME'),
                        align: 'left',
                        sortable: false,
                        value: 'name',
                        class: "transparent",
                    },
                    {
                        text: i18n.t('TENANTCENTER_TENANT_LIST.DESCRIPTION'),
                        align: 'left',
                        sortable: false,
                        value: 'description',
                        class: "transparent",
                    },
                    {
                        text: i18n.t('TENANTCENTER_TENANT_LIST.CREATED_ON'),
                        align: 'left',
                        sortable: false,
                        value: 'created_on',
                        class: "transparent",
                    },
                    {
                        text: i18n.t('TENANTCENTER_TENANT_LIST.EXPIRATION'),
                        align: 'left',
                        sortable: false,
                        value: 'subscription_end_date',
                        class: "transparent",
                    },
                    {
                        text: i18n.t('TENANTCENTER_TENANT_LIST.LICENSED'),
                        align: 'left',
                        sortable: false,
                        value: 'licensed',
                        class: "transparent",
                    },
                    {
                        text: i18n.t('TENANTCENTER_TENANT_LIST.ACTION'),
                        align: 'left',
                        sortable: false,
                        value: 'actions',
                        width: '150px',
                        class: "transparent",
                    },
                ],
                tenantListItems:[],
                addTenantDialog: false,
                addSuperUserDialog: false,
                updateSubscriptionDialog:false,
                tenantPipelineDialog:false,
                errorMessage:"",
                message:"",
                messageDialog:false,
                successDialog:false,
                errorDialog:false,
                inProcessing:false,
                showRefreshBtn:false,
                created_tenant: "",
                canManageTenants: false,
            }
        },
        mounted() {
         
        },
        created() {
            this.getTenantList();
            if (window.localStorage.getItem('tenantcenter_user')) {
                let tenantcenter_user = JSON.parse(window.localStorage.getItem('tenantcenter_user'));
                this.canManageTenants = tenantcenter_user['can_manage_tenants'];
            } else {
                this.canManageTenants = false;
            }
        },
        methods: {
            async getTenantList(){
                await TenantCenterService.tenatList().then(response => {
                    this.tenantListItems = response.data.sort((a,b) => {
                        return a.name.localeCompare(b.name);
                    });
                })
            },
            toUserListPage(data) {
                this.$router.push(`/tenant_center/user_list/${data.name}`);
            },
            onEmitAddTenantDialog(val){
                if(val.close == true){
                    const storageKey = 'new_create_tenant';
                    window.localStorage.setItem(storageKey, val.tenant);
                    this.showRefreshBtn = true;
                    this.inProcessing = true;
                    this.addTenantDialog = false;
                }
                this.showMessageDialog(i18n.t('ADD_TENANT.ADD_TENANT_WAIT'));  
            },
            onEmitNormalAddTenant(){
                this.addTenantDialog = false;
            },
            onEmitAddSuperUserDialog(){
                this.addSuperUserDialog = false;
            },
            onEmitUpdateSubscriptionDialog(){
                this.updateSubscriptionDialog = false;
            },
            onEmitTenantPipelineDialog(val){
                this.tenantPipelineDialog = false;
                if(val && val.refresh) this.getTenantList();
            },
            async onClicktoLoadData(data){
                await TenantCenterService.loadSeedData(data).then(response => {
                    if(response.data) this.showSuccessDialog();
                }).catch(response => {
                    this.showErrorDialog(response)
                })
            },
            showSuccessDialog() {
                this.successDialog = true;
            },
            async onEmitSuccessDialog() {
                this.successDialog = false;
            },
            showMessageDialog(message) {
				this.messageDialog = true;
				this.message = message;
			},
            async onEmitMessageDialog() {
                this.messageDialog = false;
            },
            showErrorDialog(message) {
                this.errorDialog = true;
                this.errorMessage = message;
            },
            onEmitErrorDialog() {
                this.errorMessage = false;
            },
            refresh(){
                let tenant = window.localStorage.getItem('new_create_tenant');
                if(!tenant){
                    return
                }else{
                    let obj = {'tenant': tenant}
                    TenantCenterService.checkTenantCreateStatus(obj)
                    .then((response)=>{
                        if(response.data == true){
                            this.showSuccessDialog();
                            this.inProcessing = false;
                            this.showRefreshBtn = false;
                            this.getTenantList()
                        }else{
                            this.showMessageDialog(i18n.t('ADD_TENANT.PROCESSING'))
                        }
                    })
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
   .tab-item-bg{
        background-color: rgba(255, 255, 255, 0.7);
    }
</style>
